import HeaderTable from "./HeaderTable";
import LineForTable from "./LineForTable";

export default function TableElements({columns, buttons, data, selectable = false, selectedIds = [], onToggleSelect = () => {}, onToggleSelectAll = () => {}}) {
    console.log("TableElements", data)
    const allSelected = data.length > 0 && data.every((element) => selectedIds.includes(element.id));

    return (
        <div className="md:block w-full shadow-md rounded-lg">
            <div className="h-[calc(100vh-18rem)] overflow-y-auto">
                <table className="w-full table-auto">
                    <HeaderTable
                        columns={columns}
                        selectable={selectable}
                        allSelected={allSelected}
                        onToggleSelectAll={onToggleSelectAll}
                        hasRows={data.length > 0}
                    />
                    <tbody className="divide-y divide-gray-200">
                        {data.map((element, index) => (
                            <LineForTable
                                key={element.id || index}
                                index={index}
                                columns={columns}
                                element={element}
                                buttons={buttons}
                                selectable={selectable}
                                selectedIds={selectedIds}
                                onToggleSelect={onToggleSelect}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}